import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-import',
  templateUrl: './web-import.component.html',
  styleUrls: ['./web-import.component.scss']
})
export class WebImportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
